import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal, SectionHead } from "../components/ui-bits";
import { useApp } from "../context/AppContext";
import { SERVICE_CARDS } from "../config/defaults";

export default function Services() {
  const { openBooking } = useApp();
  const navigate = useNavigate();

  const handleCta = (target) => {
    if (target === "business") navigate("/for-business");
    else openBooking();
  };

  const ctaLabel = (target) => (target === "business" ? "For Business" : "Book Now");

  return (
    <section id="services" className="light-section relative pb-20 lg:pb-28" data-testid="services-section">
      <div className="container-x">
        <SectionHead
          eyebrow="Services"
          light
          title={<>Car Care Built Around You.</>}
          sub="From a single doorstep wash to recurring programs for societies, corporates, dealerships and fleets."
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICE_CARDS.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.07}>
              <div className="card-light group flex h-full flex-col overflow-hidden rounded-3xl" data-testid={`service-card-${s.id}`}>
                <div className="relative h-44 overflow-hidden">
                  <img src={s.image} alt={s.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(19,8,38,0.05) 40%, rgba(19,8,38,0.55))" }} />
                  <span className="absolute left-4 top-4 rounded-full border border-white/25 bg-black/35 px-3 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-white backdrop-blur-md">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="flex flex-1 flex-col gap-3 p-6">
                  <h3 className="font-display text-lg font-semibold text-nighttext">{s.title}</h3>
                  <p className="flex-1 text-sm leading-relaxed text-[#5c5470]">{s.desc}</p>
                  <button
                    onClick={() => handleCta(s.target)}
                    className="mt-1 inline-flex items-center gap-1.5 self-start rounded-full border border-carza/30 bg-carza-dim px-4 py-2 text-[13px] font-semibold text-carza transition-all hover:gap-2.5 hover:shadow-[0_8px_20px_-8px_rgba(109,61,245,0.5)]"
                    data-testid={`service-learn-more-${s.id}`}
                  >
                    {ctaLabel(s.target)} <ArrowUpRight size={14} />
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
